import React from "react";
import styled from "styled-components";
import { mobile, mobileM, tablet } from "../responsive";
import Product from "../components/Product";
import products from "../products";

/*


This are the products on the Front page
Here you map the products to be used in the pages

*/

const HomeWrapper = styled.div`
  /* 3 images at the bottom of the home page */

  width: 100%;
  height: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;

const GalleryWrapper = styled.div`
  width: 100%;
  padding: 0px 0 40px 0;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  //
  ${mobile({ width: "100%", padding: "100px 0 50px 0" })}
  ${mobileM({ width: "100%" })}
  ${tablet({ width: "100%" })};
`;

//
//
//
const GalleryProductContainer = styled.div`
  width: 100%;
  height: 100%;

  grid-template-columns: repeat(3, 1fr);
  display: grid;
  grid-gap: 0.2em;

  /*  */
  ${mobile({
    display: "grid",
    gridGap: "0.1em",
    gridTemplateColumns: "repeat(1, 1fr)",
    padding: "none",
  })}
  ${mobileM({
    padding: "0 40px",
    display: "grid",
    gridGap: "0.2em",
    gridTemplateColumns: "repeat(1, 1fr)",
  })}
    ${tablet({
    textAlign: "center",
    padding: "0 40px",
    display: "grid",
    gridGap: "0.2em",
    gridTemplateColumns: "repeat(2, 1fr)",
  })}
`;

const Card = styled.div`
  width: 100%;
  overflow: hidden;
  height: auto;
  padding: 1% 0 0.1% 0;
`;

//
//
const HomeScreen = () => {
  return (
    <>
      <HomeWrapper>
        <GalleryWrapper>
          <GalleryProductContainer>
            {products
              .filter((product) => product.collection === "nubi")
              .map((product) => (
                <div key={product._id}>
                  <Card>
                    <Product product={product} />
                  </Card>
                </div>
              ))}
          </GalleryProductContainer>
        </GalleryWrapper>
      </HomeWrapper>
    </>
  );
};

export default HomeScreen;
